import React, { useEffect, useState } from "react";
import api from '../../../helper/util/api';

const statusStyles = {
    sending: { color: "#856404", background: "#fff3cd", label: "Sending" },
    sent: { color: "#856404", background: "#fff3cd", label: "Sent" },
    delivered: { color: "#155724", background: "#d4edda", label: "Delivered" },
    failed: { color: "#721c24", background: "#f8d7da", label: "Failed" }
};

const statusIcons = {
    sent: "📤",
    delivered: "✅",
    failed: "❌"
};

export default function CommsStatus({ leadId, data, getData }) {

    const [loading, setLoading] = useState(false);
    const [logs, setLogs] = useState(data);
    const [retryingLogs, setRetryingLogs] = useState(new Set());

    useEffect(() => {
        setLogs(data);
    }, [data]);

    const refreshLogs = async () => {

        if (loading) return;

        setLoading(true);

        const unlockTimer = setTimeout(() => {
            setLoading(false);
        }, 15000);

        try {

            // Replace with your API call
            await getData();

            clearTimeout(unlockTimer);
            setLoading(false);

        } catch (err) {
            console.error(err);
            setLoading(false);
        }
    };

    const retrySend = async (log) => {
        setRetryingLogs(prev => new Set(prev).add(log.id));
        try {
            const response = await api.post(`/deals/${leadId}/retry-comms`, { commId: log.id });
            alert("Message sent successfully!");
        } catch (err) {
            alert("Failed to retry sending message. Please try again.");
        } finally {
            await getData();
            setRetryingLogs(prev => {
                const newSet = new Set(prev);
                newSet.delete(log.id);
                return newSet;
            });
        }
    };

    return (
        <>
            <div className="section-title header">

                <h3>Communication History</h3>

                <button
                    className="refresh-btn"
                    onClick={refreshLogs}
                    disabled={loading}
                >
                    {loading ? "Refreshing..." : "Refresh"}
                </button>

            </div>

            <div className="log-list">

                {logs.map((log, index) => {

                    const style = statusStyles[log.status.toLowerCase()];

                    return (
                        <div key={index} className="log-card">

                            <div className="log-left">

                                <div className="icon">
                                    {statusIcons[log.status]}
                                </div>

                                <div className="log-info">
                                    <div className="log-title">{log.title}</div>
                                    <div className="log-time">{log.time}</div>
                                </div>

                            </div>

                            <div className="log-right">

                                <span
                                    className="status-badge"
                                    style={{
                                        color: style.color,
                                        background: style.background
                                    }}
                                >
                                    {style.label}
                                </span>

                                {log.status === "failed" && (
                                    <button
                                        className="retry-btn"
                                        onClick={() => retrySend(log)}
                                        disabled={retryingLogs.has(log.id)}
                                    >
                                        {retryingLogs.has(log.id) ? "Retrying" : "Retry"}
                                    </button>
                                )}

                            </div>

                        </div>
                    );
                })}

            </div>

            <style>{`

.container{
max-width:700px;
margin:auto;
font-family:Arial;
}

.header{
display:flex;
justify-content:space-between;
align-items:center;
margin-bottom:20px;
}

.refresh-btn{
border:none;
background:#007bff;
color:white;
padding:8px 14px;
border-radius:6px;
cursor:pointer;
font-size:13px;
}

.refresh-btn:disabled{
background:#9bbcf2;
cursor:not-allowed;
}

.log-list{
display:flex;
flex-direction:column;
gap:12px;
}

.log-card{
display:flex;
justify-content:space-between;
align-items:center;
padding:16px;
background:white;
border-radius:10px;
box-shadow:0 2px 8px rgba(0,0,0,0.08);
}

.log-left{
display:flex;
align-items:center;
gap:12px;
}

.icon{
font-size:22px;
}

.log-title{
font-weight:500;
font-size:15px;
}

.log-time{
font-size:12px;
color:#777;
margin-top:3px;
}

.log-right{
display:flex;
align-items:center;
gap:10px;
}

.status-badge{
padding:5px 12px;
border-radius:20px;
font-size:12px;
font-weight:600;
}

.retry-btn{
border:none;
background:#007bff;
color:white;
padding:6px 10px;
font-size:12px;
border-radius:6px;
cursor:pointer;
}
.retry-btn:hover{
background:#0056b3;
}
.retry-btn:disabled{
background:#9bbcf2;
cursor:not-allowed;
}

`}</style>

        </>
    );
}